document.addEventListener("DOMContentLoaded", async () => {
  console.log("Soundwave generator script loaded");

  const downloadBtn = document.querySelector("#soundwave-download-btn");
  const customerName = downloadBtn.dataset.name.trim();
  const customerId = downloadBtn.dataset.id.trim();
  const bgImage = document.querySelector(".soundwave-card__background");
  const overlay = document.querySelector(".soundwave-card__overlay");
  const waveCanvas = document.querySelector("#soundwave-canvas");
  const combinedCanvas = document.querySelector("#combined-canvas");
  
  // Set canvas sizes based on background image
  function initializeCanvasSizes() {
    combinedCanvas.width = bgImage.naturalWidth || 1000;
    combinedCanvas.height = bgImage.naturalHeight || 613;
    waveCanvas.width = combinedCanvas.width * 0.878; // 86.4% of card width
    waveCanvas.height = combinedCanvas.height * 0.42; // 42% of card height
  }

  const combinedCtx = combinedCanvas.getContext("2d");
  const waveCtx = waveCanvas.getContext("2d");
  
  // Wait for background image to load

  bgImage.onload = () => {
    initializeCanvasSizes();
    
    if (customerName && customerId) {
      generateSoundwave(customerName, customerId);
    } else {
      handleDownloadBtnState('no-name')
    }
  };

  // Generate a soundwave pattern based on a name
  function generateSoundwave(name, id) {
    
    // Clear the wave canvas
    waveCtx.clearRect(0, 0, waveCanvas.width, waveCanvas.height);
    
    // Generate a deterministic pattern based on the name
    const seed = hashString(id);
    
    // Number of bars to draw
    const barCount = 2222;
    
    // No gap
    const barWidth = waveCanvas.width / barCount; 
    
    // Draw the vertical bars
    waveCtx.fillStyle = "#000000";
    
    const centerY = waveCanvas.height / 2;
    const maxBarHeight = waveCanvas.height * 0.8;
    const minBarHeight = waveCanvas.height * 0.05;
    
    // Initialize with a mid-range height for the first bar
    let prevBarHeight = (maxBarHeight + minBarHeight) / 2;
    
    for (let i = 0; i < barCount; i++) {
      // Use a seeded random function but adjust frequency to get varying patterns
      const pos = i / barCount; // Position from 0-1 across the waveform
      const noise1 = Math.abs(seededRandom(seed + i * 0.005)); // Very slow variation
      const noise2 = Math.abs(seededRandom(seed + i * 0.5 + 100)); // Medium variation
      const combinedNoise = (noise1 * 0.7) + (noise2 * 0.3);
      
      // Calculate initial bar height with variation
      let rawBarHeight = minBarHeight + (combinedNoise * (maxBarHeight - minBarHeight));
      
      // Add some intentional "quiet zones" to create more pronounced clumps
      if (noise1 < 0.5) {
        rawBarHeight = minBarHeight;
      }
      
      // Apply the Height difference constraint
      const maxChange = waveCanvas.height * 0.01234; // % of total canvas height
      const minAllowedHeight = Math.max(prevBarHeight - maxChange, minBarHeight);
      const maxAllowedHeight = Math.min(prevBarHeight + maxChange, maxBarHeight);
      
      // Constrain the bar height
      const barHeight = Math.max(minAllowedHeight, Math.min(maxAllowedHeight, rawBarHeight));
      
      // Position the bar with no gaps
      const x = i * barWidth;
      
      // Draw from center out (symmetrical up and down)
      const halfBarHeight = barHeight / 2;
      waveCtx.fillRect(x, centerY - halfBarHeight, barWidth, barHeight);
      
      // Save this bar's height for the next iteration's constraint
      prevBarHeight = barHeight;
    }
    
    // Update the combined canvas
    drawFinalCard(name, id);
  }
  
  // Simple hash function to generate a number from a string
  function hashString(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash |= 0; // Convert to 32-bit integer
    }
    return hash;
  }
  
  // Seeded random function for consistent patterns
  function seededRandom(seed) {
    const x = Math.sin(seed) * 10000;
    return Math.abs(x - Math.floor(x)); // Ensure positive value between 0-1
  }

  // Draw the final card with background, soundwave and text
  function drawFinalCard(name, id) {
    
    // Clear the canvas
    combinedCtx.clearRect(0, 0, combinedCanvas.width, combinedCanvas.height);
    
    // Draw background image
    combinedCtx.drawImage(bgImage, 0, 0, combinedCanvas.width, combinedCanvas.height);
    
    // Draw the soundwave at the center of the card
    const waveX = (combinedCanvas.width - waveCanvas.width) / 2;  // Center horizontally
    const waveY = combinedCanvas.height * 0.5; // Center vertically
    combinedCtx.drawImage(waveCanvas, waveX, waveY - waveCanvas.height/2, 
                         waveCanvas.width, waveCanvas.height);
    
    // Add the name at the bottom of the card - we'll only add it here, not in the HTML
    combinedCtx.fillStyle = "#ffffff";
    combinedCtx.font = "120px Dissident-N27";
    
    // Position the text at the bottom, centered
    const nameText = name.toUpperCase();
    const textWidth = combinedCtx.measureText(nameText).width;
    // const textX = (combinedCanvas.width - textWidth) / 2;
    const textX = 87;
    const textY = (combinedCanvas.height * 0.9) - 28;
    
    combinedCtx.fillText(nameText, textX, textY);
    
    // Create a data URL from the canvas
    const dataURL = combinedCanvas.toDataURL("image/png");
    
    // Set the overlay source to the generated image
    overlay.src = dataURL;
    overlay.style.display = "block";
    
    // Remove any text from the soundWaveName div to prevent duplication
    const soundWaveName = document.getElementById("soundWaveName");
    if (soundWaveName) {
      soundWaveName.textContent = "";
    }

    handleDownloadBtnState(soundWaveName)
  }

  function handleDownloadBtnState(name) {
    if (name && name !== "no-name") {
      downloadBtn.innerText = "Download";
      downloadBtn.disabled = false;
    } else {
      downloadBtn.innerText = "No Name Detected";
    }
  }

  // Download button logic
  downloadBtn?.addEventListener("click", () => {
    if (overlay.style.display === "none") {
      alert("Please generate a card first");
      return;
    }
    
    combinedCanvas.toBlob((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Voice_of_${customerName}.png`;
      link.click();
    });
  });

  // Initialize with name if available
  if (bgImage.complete) {
    initializeCanvasSizes();
    if (customerName && customerId) {
      setTimeout(() => {
        generateSoundwave(customerName, customerId);
      }, 200); // Small delay to ensure DOM is ready
    } else {
      handleDownloadBtnState('no-name');
    }
  }
});